import Icon from '../../../../components/Icon'
import { Column, Title, Link, ProfileImage, Message } from "./styles";
import { connect } from "react-redux";
import userAvatar from "../../../../assets/avatar.svg";
import { ReactElement, useMemo } from 'react';
import whatsappIcon from '../../../../assets/icons/whatsapp.svg'
import Image from '../../../../components/Image'
import mercadoPagoImg from '../../../../assets/mercado-pago.png'
import { useTheme } from 'styled-components';
import constants from '../../../../constants';
import { Group, User } from '../../../../types';

interface ComponentProps {
  group: Group
  user: User
  text?: ReactElement
}

const Component = ({ group, user, text }: ComponentProps) => {
  const theme = useTheme() as { logo: { small: string, big: string } };

  const profilePicture = useMemo(() => {
    return group?.expert?.profile_pic?.url || userAvatar
  }, [group])

  return (
    <Column>
      <div style={{ gap: 24, display: 'flex', justifyContent: 'center', width: '100%', maxWidth: 410 }}>
        <Image
          src={theme?.logo?.big}
          style={{ display: 'block' }}
          width="107px"
          height="auto"
          className="logo-desktop"
          alt="Klouser"
          lazy
        />

        <div style={{ height: 30, width: 1, backgroundColor: '#B1C6E4' }} />

        <Image
          src={mercadoPagoImg}
          style={{ display: 'block' }}
          width="101px"
          height="auto"
          className="logo-desktop"
          alt="Mercado pago"
          lazy
        />
      </div>

      <div style={{ height: 52 }} />

      <ProfileImage loading="lazy" src={profilePicture} alt={"Profile Image"} />
      <div style={{ height: 42 }} />
      <Title>Hubo un inconveniente​</Title>
      <div style={{ height: 42 }} />
      <Message>{!!text ? text : <>Lamentablemente, el pago a {group?.group_name}<br />no se pudo completar 😔.<br />No te preocupes, estas cosas pasan.<br /><br />👉 Por favor, contáctate con nuestro<br />soporte para solucionarlo rápidamente.<br />¡Gracias por tu paciencia!</>}</Message>
      <div style={{ height: 42 }} />
      <Link
        options={{ type: 'outline', size: 'lg', skin: 'purple', block: true, native: false }}
        href={`${constants.whatsapp.url}?phone=${constants.whatsapp.number
          }&text=${constants.whatsapp.checkout_failure.replace("{name}", user?.name).replace("{email}", user?.email)}`}
        target="_blank"
      >
        <Icon size='20px' icon={whatsappIcon} color="#000000" />
        Contactarme con soporte
      </Link>
    </Column>
  )
}

const state = ({ groupStore, userStore }) => {
  const { data: group } = groupStore?.group;
  const { data: user } = userStore.information;

  return { group, user };
};

export default connect(state)(Component);